import { render, staticRenderFns } from "./Deactivate.vue?vue&type=template&id=19163e2c&scoped=true&"
import script from "./Deactivate.vue?vue&type=script&lang=js&"
export * from "./Deactivate.vue?vue&type=script&lang=js&"
import style0 from "./Deactivate.vue?vue&type=style&index=0&id=19163e2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19163e2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VDialog})
